import ErrorNoMentors from '../../errors/pages/errorNoMentors';

const NoMentors = () => {
  return <ErrorNoMentors />;
};

export default NoMentors;
